import { render, staticRenderFns } from "./educationCentre.vue?vue&type=template&id=586d8820&scoped=true"
import script from "./educationCentre.vue?vue&type=script&lang=js"
export * from "./educationCentre.vue?vue&type=script&lang=js"
import style0 from "./educationCentre.vue?vue&type=style&index=0&id=586d8820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d8820",
  null
  
)

export default component.exports